import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  logError(message: string, stack?: string): void {
    console.error(message, stack);
  }

  sendErrorToServer(message: string, stack?: string): void {
    // Reservado para envio futuro de telemetria de erros HTTP.
    console.warn('[remote-error]', message, stack);
  }
}
